/**
 * OAuth popup providers (Azure MPC, CRM, Slack, etc.) redirect back into the
 * Labra SPA. Those pages only postMessage to window.opener and close — they
 * must not require Auth0, or the popup is sent to accounts.labra.io/login.
 *
 * Azure (settings + onboarding): both flows call the same azure-engine
 * auth_response initiate. MSAL redirect_uri is AZURE_REDIRECT_URL, e.g.
 *   /settings/oppsync/cloud/azure/callback
 * Onboarding does NOT use a separate Microsoft redirect. After the popup
 * posts the code, the parent navigates to:
 *   /oppsync/onboarding/cloud-settings?...  (already Auth0-authenticated)
 */
export const OAUTH_POPUP_CALLBACK_PATHS = [
  '/settings/oppsync/cloud/azure/callback',
  '/settings/crm/callback',
  '/settings/integrations/callback',
  '/settings/notifications/callback',
] as const

const normalizePathname = (pathname: string): string =>
  pathname.replace(/\/+$/, '') || '/'

/** Azure MPC popup callback (settings or onboarding share this Microsoft redirect). */
const isAzureOauthPopupCallbackPath = (pathname: string): boolean =>
  /^\/settings\/[^/]+\/cloud\/azure(?:\/[^/]+)?\/callback$/.test(pathname)

export const isOauthPopupCallbackPath = (pathname: string): boolean => {
  const normalized = normalizePathname(pathname)
  if (
    (OAUTH_POPUP_CALLBACK_PATHS as readonly string[]).includes(normalized)
  ) {
    return true
  }
  return isAzureOauthPopupCallbackPath(normalized)
}
